<template>
<ItpBox
  alignItems="center"
  class="w-100"
  v-if="loaded"
>
  <ItpText
    muted
    :text="resourceTitle"
    class="mb-0 mx-2"
  >
  </ItpText>
  <ItpText
    tag="h5"
    :text="resourceKey"
    class="mb-0 mx-2"
  >
  </ItpText>
  <UcJobNameBadge
    :value="item.name"
    class="mx-2"
  >
  </UcJobNameBadge>
  <UcStatusBadge
    :status="item.status"
    class="mx-2"
  >
  </UcStatusBadge>
  <ItpText
    strong
    class="mx-2"
  >
    {{ item.submit_time|datetime }}
  </ItpText>
  <ItpText
    strong
    no-wrap
    class="mx-2 text-truncate"
    :style="b_1382594685840889_style"
  >
    {{ item.created_by|username }}
  </ItpText>
  <b-button-group
    class="ml-auto"
  >
    <ItpButton
      icon="fa-sync-alt"
      :tooltip="'Reload'|gettext"
      :spinning="actions.reload.isRunning"
      variant="light"
      class="ml-auto"
      @click.prevent.stop="evh_2754826507016131_clickPreventStop($event, {})"
    >
    </ItpButton>
  </b-button-group>
  <b-dropdown
    right
    variant="light"
    class="border"
  >
    <ItpIcon
      fa="bars"
      class="mx-1"
      slot="button-content"
    >
    </ItpIcon>
    <ItpButton
      dropdown-item
      :text="'Retry'|pgettext('Job')"
      size="sm"
      class="mr-2"
      v-if="item.links.retry"
      @click.prevent.stop="evh_7463771596263925_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      dropdown-item
      :text="'Cancel'|pgettext('Job')"
      size="sm"
      class="mr-2"
      v-if="item.links.cancel"
      @click.prevent.stop="evh_7763705103899431_clickPreventStop($event, {})"
    >
    </ItpButton>
  </b-dropdown>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class JobHeader extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  messages!: any;
  ux!: any;
  b_1382594685840889_style!: any;
  dataMembers = ['messages', 'ux', 'b_1382594685840889_style'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          title: this.$fn.pgettext("Job|ModalHeader", "Job"),
        }
        ,
        ux: null,
        b_1382594685840889_style: {
          maxWidth: "80px",
        }
        ,
      },
    }
  }

  get resourceTitle() {
    if (this.loaded) {

      return this.$fn.pgettext("Job|ModalHeader", "Job")
    }
    return null;
  }

  get resourceKey() {
    if (this.loaded) {

      return '#' + this.item.number
    }
    return null;
  }

  async act_2754826507016131_emit_7738_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_2754826507016131_emit_7738, alias=reload
    return {
      event: "reload",
    }
  }

  async evh_2754826507016131_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2754826507016131_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_7463771596263925_emit_7742_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7463771596263925_emit_7742, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_7463771596263925_request_7740_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_7463771596263925_request_7740, alias=retryJob
    return {
      url: this.item.links.retry,
      method: "PATCH",
      headers: {
        "If-Match": this.item.etag,
      }
      ,
    }
  }

  async evh_7463771596263925_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7463771596263925_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_7763705103899431_emit_7746_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7763705103899431_emit_7746, alias=undefined
    return {
      event: "reload",
    }
  }

  async act_7763705103899431_request_7744_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_7763705103899431_request_7744, alias=cancelJob
    return {
      url: this.item.links.cancel,
      method: "PATCH",
      headers: {
        "If-Match": this.item.etag,
      }
      ,
    }
  }

  async evh_7763705103899431_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7763705103899431_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_2754826507016131_emit_7738: actions.EmitAction;
    evh_2754826507016131_clickPreventStop_7737: actions.EventHandlerImpl;
    evh_2754826507016131_clickPreventStop: actions.EventHandlerGroup;
    act_7463771596263925_emit_7742: actions.EmitAction;
    evh_7463771596263925_success_7741: actions.EventHandlerImpl;
    act_7463771596263925_request_7740: actions.RequestAction;
    evh_7463771596263925_clickPreventStop_7739: actions.EventHandlerImpl;
    evh_7463771596263925_clickPreventStop: actions.EventHandlerGroup;
    act_7763705103899431_emit_7746: actions.EmitAction;
    evh_7763705103899431_success_7745: actions.EventHandlerImpl;
    act_7763705103899431_request_7744: actions.RequestAction;
    evh_7763705103899431_clickPreventStop_7743: actions.EventHandlerImpl;
    evh_7763705103899431_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_2754826507016131_emit_7738 = new actions.EmitAction(
      {
        actionArgs: this.act_2754826507016131_emit_7738_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_2754826507016131_clickPreventStop_7737 = new actions.EventHandlerImpl(
      {
        action: act_2754826507016131_emit_7738,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_2754826507016131_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2754826507016131_clickPreventStop_7737],
      }
    );
    const act_7463771596263925_emit_7742 = new actions.EmitAction(
      {
        actionArgs: this.act_7463771596263925_emit_7742_getActionArgs,
        events: [],
      }
    );
    const evh_7463771596263925_success_7741 = new actions.EventHandlerImpl(
      {
        action: act_7463771596263925_emit_7742,
        event: "success",
        displayName: "emit",
      }
    );
    const act_7463771596263925_request_7740 = new actions.RequestAction(
      {
        actionArgs: this.act_7463771596263925_request_7740_getActionArgs,
        displayName: "retryJob",
        events: [evh_7463771596263925_success_7741],
      }
    );
    const evh_7463771596263925_clickPreventStop_7739 = new actions.EventHandlerImpl(
      {
        action: act_7463771596263925_request_7740,
        event: "click.prevent.stop",
        displayName: "retryJob",
      }
    );
    const evh_7463771596263925_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_7463771596263925_clickPreventStop_7739],
      }
    );
    const act_7763705103899431_emit_7746 = new actions.EmitAction(
      {
        actionArgs: this.act_7763705103899431_emit_7746_getActionArgs,
        events: [],
      }
    );
    const evh_7763705103899431_success_7745 = new actions.EventHandlerImpl(
      {
        action: act_7763705103899431_emit_7746,
        event: "success",
        displayName: "emit",
      }
    );
    const act_7763705103899431_request_7744 = new actions.RequestAction(
      {
        actionArgs: this.act_7763705103899431_request_7744_getActionArgs,
        displayName: "cancelJob",
        events: [evh_7763705103899431_success_7745],
      }
    );
    const evh_7763705103899431_clickPreventStop_7743 = new actions.EventHandlerImpl(
      {
        action: act_7763705103899431_request_7744,
        event: "click.prevent.stop",
        displayName: "cancelJob",
      }
    );
    const evh_7763705103899431_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_7763705103899431_clickPreventStop_7743],
      }
    );
    return {
      act_2754826507016131_emit_7738,
      evh_2754826507016131_clickPreventStop_7737,
      evh_2754826507016131_clickPreventStop,
      act_7463771596263925_emit_7742,
      evh_7463771596263925_success_7741,
      act_7463771596263925_request_7740,
      evh_7463771596263925_clickPreventStop_7739,
      evh_7463771596263925_clickPreventStop,
      act_7763705103899431_emit_7746,
      evh_7763705103899431_success_7745,
      act_7763705103899431_request_7744,
      evh_7763705103899431_clickPreventStop_7743,
      evh_7763705103899431_clickPreventStop,
      reload: act_2754826507016131_emit_7738,
      retryJob: act_7463771596263925_request_7740,
      cancelJob: act_7763705103899431_request_7744,
    }
  }
}

Vue.component("JobHeader", JobHeader);

</script>